/*
================================================================================
|                                                                              |
|  FILE: src/hooks/usePageTracking.js                                          |
|  PURPOSE: Custom hook to track page views in Google Analytics               |
|                                                                              |
================================================================================
*/
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or use a default
    const pageTitle = document.title || 'Milliardi Energo';
    const pagePath = location.pathname + location.search;

    // Track the page view
    trackPageView(pageTitle, pagePath);

    // Log for debugging
    console.log(`Page view tracked: ${pageTitle} - ${pagePath}`);
  }, [location]);
};

export default usePageTracking; 